import React, {FormEvent, useState} from "react";
import {GenerateInvitationRequest, GenerateInvitationResponse} from "../../../compiled";
import {useRpcSender} from "../../../rpcSender";
import {getBookingHost} from "../../../Util/HostUtils";

export const UsersTab = () => {

  const rpcSender = useRpcSender();

  // The RPC callback from generated an invite. Setting this as state
  // causes it to render a message
  const [generatingCodes, setGeneratingCodes] = useState(false);
  const [generatingCodesError, setGeneratedCodesError] = useState('');
  const [response, setResponse] = useState<GenerateInvitationResponse>();

  const generateInvites = function (event: FormEvent<HTMLFormElement>) {

    event.preventDefault();

    setGeneratingCodes(false);
    setGeneratedCodesError('');

    let request = GenerateInvitationRequest.encode(new GenerateInvitationRequest({
      num: 1
    })).finish();

    rpcSender.send('generate_user_invite', request).then(r => {
      let response = GenerateInvitationResponse.decode(r);
      console.log('invite response', response);
      setResponse(response);

    }).catch(e => {
      console.log(e);
      setGeneratedCodesError('Error generating invites. ' + e)
    }).finally(() => {
      setGeneratingCodes(false);
    });
  };

  return (
      <>
        <div>
          <b>User admin</b>
          <br/>
          <br/>
        </div>

        <div>
          Generate an alpha invite code<br/><br/>
          <form onSubmit={generateInvites}>
            <button type="submit" value="Submit">Generate the code!!</button>
          </form>
          
          {generatingCodesError &&
              <div style={{color: 'red'}}>Error generating invite! {generatingCodesError}</div>}

          {response && response.inviteCodes &&
              <div>
                <br/>
                Please share this URL to invite a new user to the Kenko alpha
                <br/>

                {response.inviteCodes.map(code => {
                  return <a href={`${getBookingHost()}/join?inviteCode=${code}`}>
                    {getBookingHost()}/join?inviteCode={code}
                  </a>
                })
                }
              </div>
          }
        </div>
      </>
  );
}
